import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { AlertLoading } from './components/AlertContent/Loading';
/**
 * Lazy loaded component renderer with a loader fallback.
 *
 * @note - each lazy component should have a skeleton loader and not generic loader if possible
 */ export function LazyLoadedComponent(param) {
    let { component, children, fallback = /*#__PURE__*/ _jsx(AlertLoading, {
        isLoading: true
    }) } = param;
    if (!component && !children) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: fallback,
        children: component !== null && component !== void 0 ? component : children
    });
}
